import React from 'react'
import { SvgIconProps } from './Home'

const SvgCircularWarningIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    width={width ?? '24'}
    height={height ?? '24'}
    // viewBox={`0 0 ${width ?? '24'} ${height ?? '24'}`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3C16.9787 3 21 7.02128 21 12C21 16.9787 16.9787 21 12 21C7.02129 21 3 16.9787 3 12C3 7.02129 7.02129 3.00002 12 3ZM12.2783 15.5C11.7814 15.5002 11.3789 15.9035 11.3789 16.4004C11.3791 16.8972 11.7816 17.2996 12.2783 17.2998C12.7752 17.2998 13.1785 16.8973 13.1787 16.4004C13.1787 15.9033 12.7754 15.5 12.2783 15.5ZM12.25 7C11.3233 7.00001 10.608 7.81574 10.7295 8.73438L11.4014 13.8018C11.4578 14.2273 11.8207 14.5459 12.25 14.5459C12.6793 14.5459 13.0422 14.2273 13.0986 13.8018L13.7705 8.73438C13.892 7.81573 13.1767 7 12.25 7Z"
      fill={fill ?? 'white'}
    />
  </svg>
)

export default SvgCircularWarningIcon
